import { route, } from 'mithril'
import { fetchUtils, } from 'utils/fetch';
import { postId, get as getFromPdo, punditData, }
  from 'application/pageDataObject';
const { matchId, } = punditData;
const { getJsonOrError, getResponseText, } = fetchUtils;
const POST_METADATA = `Post_${ postId }`;
const REACTIONS = `PostReactions_${ postId }`;

function shouldLoadPundit(){
  return !!matchId;
}
const ACTION_COUNTER_VBET = `MatchVbetsDistribution_${ matchId }`
const ACTION_COUNTER_KEYS = [REACTIONS, POST_METADATA, ]
  .concat(shouldLoadPundit() ? [ACTION_COUNTER_VBET, ]: []);
const ACTION_COUNTER_PDO_BASE_KEY = 'config.action_counter';
const NO_HOST = null;

let actionProviderHosts = null;

function getActionProviderHosts(){
  if (actionProviderHosts) {
    return actionProviderHosts;
  }
  const [WRITER_ACTION_PROVIDER,READER_ACTION_RPVIDER, ] = ['host','slave']
    .map(i => getFromPdo(`${ ACTION_COUNTER_PDO_BASE_KEY }.${ i }`), NO_HOST);
  actionProviderHosts = { READER_ACTION_RPVIDER, WRITER_ACTION_PROVIDER, };
  return actionProviderHosts;
}

let fetchPromise = null;

function canSendData(){
  const hostsUrls = getActionProviderHosts();
  const reportingTargets = Object.keys(hostsUrls).map(k => hostsUrls[k]);
  return !reportingTargets.includes(NO_HOST);
}
function getFetchUrlByKeys(keys){
  const hosts = getActionProviderHosts();
  const { READER_ACTION_RPVIDER: baseUrl, } = hosts;
  return `//${ baseUrl }/get?`+keys.map(k=> `key=${ k }&`).join('');
}
function fetchCounters(){
  const url = getFetchUrlByKeys(ACTION_COUNTER_KEYS);
  return fetchPromise = fetchPromise || getJsonOrError(url);
}
function fetchCounterByKey(key){
  return fetchCounters().then(counters => counters[key]);
}
export function fetchReactions(){
  return fetchCounterByKey(REACTIONS);
}
export function fetchPostMetadata(){
  return fetchCounterByKey(POST_METADATA);
}
export function fetchMatchVbetDistribution(){
  if (!shouldLoadPundit()) {
    return Promise.reject('pundit is not being used in this post');
  }
  return fetchCounterByKey(ACTION_COUNTER_VBET);
}
export function sendData(type, params = {}){
  if (!canSendData()) {
    return Promise.reject('cannot report to action counter.');
  }
  params.ts = Date.now();
  const { WRITER_ACTION_PROVIDER: baseUrl, } = getActionProviderHosts();
  const serializedParams = route.buildQueryString(params);
  const url = `//${ baseUrl }/${ type }?${ serializedParams }`;
  return getResponseText(url);
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/actionCounter/currentPostActionCounterProvider.js